export default "__VITE_ASSET__$cmH0nDA__"